import React, { forwardRef } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from "recharts";
import { SectionCard, InfoRow, ChartTooltip, fmtNum, barLabelStyle, C, axisTick } from "../shared";

const DividendsSection = forwardRef(({ dividends }, ref) => {
  const hasHistory = dividends.history?.length > 0;
  return (
    <SectionCard ref={ref} id="dividends" icon="dividends" title="Dividends">
      <div className="tdash-g2">
        <div>
          <InfoRow label="Latest Dividend"      value={dividends.latest_dividend != null ? `Rs. ${fmtNum(dividends.latest_dividend)}` : null} />
          <InfoRow label="Last Annual Dividend" value={dividends.last_annual_dividend != null ? `Rs. ${fmtNum(dividends.last_annual_dividend)}` : null} />
          {!hasHistory && <div className="tdash-muted" style={{ padding: "16px 0" }}>No dividend history</div>}
        </div>
        {hasHistory && (
          <div>
            <div style={{ fontSize: 11, color: C.muted, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 8 }}>Dividend History</div>
            <ResponsiveContainer width="100%" height={210}>
              <BarChart data={dividends.history} margin={{ top: 18, right: 8, left: 0, bottom: 0 }} barCategoryGap="35%">
                <CartesianGrid strokeDasharray="3 3" stroke={C.grid} vertical={false} />
                <XAxis dataKey="year" tick={axisTick} tickLine={false} axisLine={{ stroke: C.border }} />
                <YAxis tick={axisTick} tickLine={false} axisLine={false} width={38} />
                <Tooltip content={<ChartTooltip />} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
                <Bar dataKey="dividend" name="Dividend" fill={C.orange} radius={[3, 3, 0, 0]} maxBarSize={18} isAnimationActive={false}>
                  <LabelList dataKey="dividend" position="top" style={barLabelStyle} formatter={(v) => fmtNum(v)} />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </SectionCard>
  );
});

export default DividendsSection;
